import React, {Fragment} from 'react';

import {DISCOUNT_DYNAMIC_PROPERTIES, DISCOUNT_MAIN_TYPES, DISCOUNT_MODES, DISCOUNT_TYPES} from "./discounstInterface";
import {
  getPriceWithCurrency,
  getQuotePriceWithDiscounts,
  getTotalPrice,
  sortByOrder,
  toFixedPrice
} from "../../misc/helpers";
import {
  calculateDeposit,
  getDiscountCurrentValue,
  getDiscountsForSection,
  getDiscountSubTotalPrice,
  shouldDisplayDiscount,
} from "./discountFunctions";
import TextInput from "../ui/textInput";

export default class DiscountCommon extends React.Component {

  shouldComponentUpdate(nextProps) {
    return !nextProps.jobIsSaving;
  }

  handleDiscountSelectClick = () => {
    if (this.isDiscountDisabled()) {
      return false
    }
    const selected = !this.props.discount.selected;
    this.setDiscountProperty("selected", selected);
    if (this.props.fabricatorData.isAmericanStandard) {
      if ((this.props.discount.discountType === DISCOUNT_MAIN_TYPES.subTotal)
        && (this.props.discount.name === "Price Good for Today")) {
        this.props.setFinanceCellsVisible(selected);
        if (!selected && this.props.financeActiveDiscount) {
          this.props.setFinanceActiveDiscount(null);
        }
      }
    } else {
      if ((this.props.discount.discountType === DISCOUNT_MAIN_TYPES.subTotal) && !this.props.financeCellsVisible) {
        this.props.setFinanceCellsVisible(true);
      }
    }
    if (this.props.financeActiveDiscount && this.discountIsCashAndSelected(this.props.discount, selected)) {
      this.props.setFinanceActiveDiscount(null);
    }
  };

  someDiscountIsCashAndSelected = (customAddedDiscounts = this.props.customAddedDiscounts, discountSections = this.props.discountSections) => {
    return customAddedDiscounts.some(customDiscount => {
      return customDiscount.selected && customDiscount.name && customDiscount.name.includes("Cash")
    }) || discountSections.some(section => {
      return section.discounts.some(dis => this.discountIsCashAndSelected(dis))
    })
  }

  discountIsCashAndSelected = (discount, selected) => {
    const discountSelected = typeof selected !== "undefined" ? selected : discount.selected;
    return discountSelected && (discount.type === DISCOUNT_TYPES.price) && (discount.name && discount.name.includes("Cash"))
  }

  someDiscountIsSubTotalAndSelected = () => {
    return this.props.discountSections.some(discountSection => {
      return discountSection.discounts.some(discount => {
        const realSelected = getDiscountCurrentValue(
          discount,
          "selected",
          this.props.activeQuoteIndex,
          this.props.hasMultipleWorkSheets
        );
        return realSelected && (discount.discountType === DISCOUNT_MAIN_TYPES.subTotal) && (discount.name === "Price Good for Today")
      })
    })
  }

  setDiscountProperty = (property, value) => {
    const currentDiscount = this.updateDiscountRoomValues(this.props.discount, property, value);
    return this.updateDiscount(currentDiscount);
  };

  updateDiscountRoomValues = (discount, property, value) => {
    if (this.props.hasMultipleWorkSheets) {
      if (!discount.roomValues) {
        discount.roomValues = {};
      }
      if (!discount.defaultValues) {
        discount.defaultValues = {};
        DISCOUNT_DYNAMIC_PROPERTIES.forEach(prop => {
          discount.defaultValues[prop] = discount[prop]; // selected is undefined, it's ok
        });
      }
      if (!discount.roomValues[this.props.activeQuoteIndex]) {
        discount.roomValues[this.props.activeQuoteIndex] = {};
      }
      DISCOUNT_DYNAMIC_PROPERTIES.forEach(prop => {
        discount.roomValues[this.props.activeQuoteIndex][prop] = (prop === property) ? value : discount[prop];
      });
    }
    discount[property] = value;
    return discount;
  }

  updateDiscount = (currentDiscount) => {
    const newSections = this.props.discountSections.map((discountSection) => {
      if (discountSection.order === this.props.discountSection.order) {
        discountSection.discounts.map(discount => {
          if (currentDiscount.order === discount.order) {
            return currentDiscount
          }
          return discount
        });
        if (currentDiscount.selected && currentDiscount.mode === DISCOUNT_MODES.or && !currentDiscount.isSubTotal) {
          discountSection.discounts = discountSection.discounts.map(discount => {
            if ((currentDiscount.order !== discount.order) && (discount.mode === DISCOUNT_MODES.or) && !discount.isSubTotal) {
              discount = this.updateDiscountRoomValues(discount, "selected", false);
            }
            return discount
          });
        }
      }
      return discountSection
    })
    this.props.setDiscountSections(newSections);
    return newSections
  };

  getGrandTotal = (withoutDiscount = null) => {
    const totalPrice = getTotalPrice(null, false);
    return getQuotePriceWithDiscounts(totalPrice, withoutDiscount ? [withoutDiscount] : [], false, this.props.activeQuoteIndex);
  }

  isDiscountDisabled = (forDiscount = this.props.discount) => {
    const {discountSection, customAddedDiscounts, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const discount = forDiscount;
    const realSelected = getDiscountCurrentValue(discount, "selected", activeQuoteIndex, hasMultipleWorkSheets);

    if (realSelected) {
      return false
    }
    const grandTotal = this.getGrandTotal();
    const realAmount = getDiscountCurrentValue(discount, "amount", activeQuoteIndex, hasMultipleWorkSheets);
    const realType = getDiscountCurrentValue(discount, "type", activeQuoteIndex, hasMultipleWorkSheets);

    const discountAmount = realType === DISCOUNT_TYPES.price ? realAmount : grandTotal * realAmount / 100;
    let disabled = (grandTotal - discountAmount) < 0;
    if (disabled && discount.mode === DISCOUNT_MODES.or) {
      const allDiscounts = sortByOrder(getDiscountsForSection(discountSection, customAddedDiscounts));
      if (allDiscounts.some(currentDiscount => {
        return (currentDiscount.order !== discount.order) // take othere discounts from this section
          && (currentDiscount.mode === DISCOUNT_MODES.or) // with OR mode
          && shouldDisplayDiscount(currentDiscount, activeQuoteIndex, hasMultipleWorkSheets) // already selected
          && (this.getGrandTotal(currentDiscount) - discountAmount) > 0
        // price without this discount minus current discount amount still more than 0
      })) {
        disabled = false
      }
    }
    return disabled
  }

  getDiscountPercentageAmount = () => {
    const {discount, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const realAmount = getDiscountCurrentValue(discount, "amount", activeQuoteIndex, hasMultipleWorkSheets);

    const grandTotal = getDiscountSubTotalPrice(this.props.discountSections, this.props.discountSection, this.props.discount, true, this.props.customAddedDiscounts, activeQuoteIndex, hasMultipleWorkSheets);
    const priceTaken = grandTotal * realAmount / 100 // for ex. 25% from 2700 = 625
    return toFixedPrice(Math.trunc(priceTaken * 100) / 100);
  };

  setAmountValue = (value) => {
    // console.log("value", value);
    const {discount, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const realType = getDiscountCurrentValue(discount, "type", activeQuoteIndex, hasMultipleWorkSheets);

    if ((discount.discountType === DISCOUNT_MAIN_TYPES.deposit) && (realType === DISCOUNT_TYPES.percent)) {
      this.setDiscountProperty("type", DISCOUNT_TYPES.price);
    }
    this.setDiscountProperty("amount", +value)
  };

  getMaxDiscountValue = () => {
    const {discount, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const realType = getDiscountCurrentValue(discount, "type", activeQuoteIndex, hasMultipleWorkSheets);
    return (realType === DISCOUNT_TYPES.percent) && (discount.discountType !== DISCOUNT_MAIN_TYPES.deposit) ? 100 : this.getGrandTotal(discount)
  }

  getDiscountAmount = () => {
    const {discount, activeQuoteIndex, hasMultipleWorkSheets, fabricatorSettings} = this.props;
    const realType = getDiscountCurrentValue(discount, "type", activeQuoteIndex, hasMultipleWorkSheets);
    const realAmount = getDiscountCurrentValue(discount, "amount", activeQuoteIndex, hasMultipleWorkSheets);

    return realType === DISCOUNT_TYPES.price
      ? "-" + getPriceWithCurrency(fabricatorSettings, realAmount)
      : "-" + getPriceWithCurrency(fabricatorSettings, this.getDiscountPercentageAmount())
  }

  getInputValue = () => {
    const {discount, fabricatorSettings, discountSections, hasMultipleWorkSheets, activeQuoteIndex} = this.props;
    const realType = getDiscountCurrentValue(discount, "type", activeQuoteIndex, hasMultipleWorkSheets);
    const realAmount = getDiscountCurrentValue(discount, "amount", activeQuoteIndex, hasMultipleWorkSheets);

    if (!realAmount) {
      return "0"
    }
    if (discount.discountType === DISCOUNT_MAIN_TYPES.deposit) {
      if (realType === DISCOUNT_TYPES.price) {
        return getPriceWithCurrency(fabricatorSettings, toFixedPrice(realAmount))
      }
      let customDepositAmount = calculateDeposit(discountSections, discount, activeQuoteIndex, hasMultipleWorkSheets);
      return getPriceWithCurrency(fabricatorSettings, customDepositAmount);
    }
    // return "-" + (discount.type === DISCOUNT_TYPES.price) // we can't have percentages free fill discounts
    //   ? fabricatorSettings.currencySign + discount.amount
    //   : discount.amount + "%"
    return "-" + getPriceWithCurrency(fabricatorSettings, toFixedPrice(realAmount))
  }

  renderAmountInput = () => {
    const {discount, fabricatorData} = this.props;
    const isDiscount = discount.discountType === DISCOUNT_MAIN_TYPES.deposit;
    return discount.selected || isDiscount ? (
      <Fragment>
        {/*<span className="discount-special__type">*/}
        {/*  -{discount.type === DISCOUNT_TYPES.percent ? "%" : fabricatorData.settings.currencySign}*/}
        {/*</span>*/}
        <TextInput className={"ui-input discount-special__amount discount-cell--active-color price-input"}
                   numberInput={true}
                   onChange={this.setAmountValue}
                   onRealChange={this.setAmountValue}
                   maxValue={this.getMaxDiscountValue()}
                   currencySing={isDiscount ? fabricatorData.settings.currencySign : "-" + fabricatorData.settings.currencySign}
                   value={this.getInputValue()}/>
        {/*{discount.type === DISCOUNT_TYPES.percent*/}
        {/*  ? <span className="discount-cell--amount bold">{this.getDiscountAmount()}</span>*/}
        {/*  : null}*/}
      </Fragment>
    ) : null
  }

}
